import { useSelector } from 'react-redux';
import { RootState } from '../store/state';

export const useOptionsState = () =>
    useSelector<RootState, RootState['options']>(state => state.options);
